/**
 * Return a new set that contains all elements of `set1` except those
 * that are also in `set2`.
 *
 * @param {Set} set1 - The Set containing the elements that the result
 * should contain.
 * @param {Set} set2 - The Set containing the elements that the result
 * should not contain.
 */
export function difference(set1, set2) {
	const result = new Set(set1);

	for (const item of set2) {
		result.delete(item);
	}

	return result;
}
